export const slidersData = [
    {
        image: "onboard01",
        heading: "Car buying, redefined",
        description: "Explore top picks, compare with ease, and get the best deals. Expert help at every step."
    },
    {
        image: "onboard02",
        heading: "Car service, simplified",
        description: "Free pick-up, same-day return, and only genuine parts. Quality service without the chaos."
    },
    {
        image: "onboard03",
        heading: "Car selling, made stress-free",
        description: "Get your car’s best price in minutes with expert support and a free doorstep inspection."
    },
    {
        image: "onboard04",
        heading: "And the everyday car stuff",
        description: "From challans and FASTag to PUCC, we handle the small things that keep you moving."
    },
]